/**
 * Shown the first time the preview opens : the preview is the last look at the album
 * before ordering, so we invite the user to go through it (design "Sous la loupe").
 *
 * It slides down from the top, and back up when it closes.
 *
 * Mandatory : no close cross, neither Escape nor a click behind closes it — only
 * "Vérifier mon album" does. Escape is held back from the preview too, which would
 * otherwise go back to the editor from under the popup.
 *
 *   this.popup(new common.popups.PreviewReady({ onContinue : () => ... }));
 */
fx.ns("common.popups", class PreviewReady extends fx.Component {

    constructor({ onContinue = () => {} } = {})
    {
        super();

        this.onContinue = onContinue;

        this._onKey = this._onKey.bind(this);
    }

    onReady()
    {
        super.onReady();

        this._cta = this.find(".fl-preview__cta");
        this.on("click", this._onContinue, this._cta);

        this._lastFocus = document.activeElement;
        this._overflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = "hidden";

        // capture on window : runs before fx.keyboard, which listens there too
        window.addEventListener("keydown", this._onKey, true);
        window.addEventListener("keyup", this._onKey, true);

        this._cta.focus();
    }

    close()
    {
        if (this._closed)
            return;

        this._closed = true;
        this._release();
        this.addClass("closing");
        this.delay(this._hidden, this._reducedMotion ? 0 : this.SLIDE_OUT);
        this.trigger("closed");
    }

    // the card slides back up, then goes
    _hidden()
    {
        this.hide(this.destroy.bind(this));
    }

    // ms the card takes to slide up when it closes, as in PreviewReady.scss
    get SLIDE_OUT() { return 300; }

    get _reducedMotion()
    {
        return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    }

    destroy()
    {
        this._release();
        super.destroy();
    }

    _release()
    {
        window.removeEventListener("keydown", this._onKey, true);
        window.removeEventListener("keyup", this._onKey, true);

        if (this._lastFocus === undefined)
            return;

        document.documentElement.style.overflow = this._overflow;

        if (this._lastFocus && this._lastFocus.focus)
            this._lastFocus.focus();

        this._lastFocus = undefined;
    }

    _onContinue()
    {
        this.close();
        this.onContinue();
    }

    // Escape does nothing, Tab stays on the only button
    _onKey(e)
    {
        if (e.key === "Escape" || e.keyCode === 27)
        {
            e.preventDefault();
            e.stopPropagation();
        }
        else if (e.key === "Tab" && e.type === "keydown")
        {
            e.preventDefault();
            this._cta.focus();
        }
    }

    render()
    {
        let asset = fx.get("assets").personAdvice,
            photo = asset instanceof fx.Asset ? asset.content : asset,
            title = fx.text("L'aperçu de votre album est prêt !").replace(/ !$/, "&nbsp;!");

        return  '<div class="fl-preview">' +
                    '<div class="fl-preview__overlay">' +
                        '<div class="fl-preview__dialog" role="dialog" aria-modal="true" aria-labelledby="flPreviewTitle" aria-describedby="flPreviewText">' +
                            '<div class="fl-preview__hero" aria-hidden="true">' +
                                '<div class="fl-preview__spread">' +
                                    '<div class="fl-preview__page-left"><span></span><span></span><span></span><span></span></div>' +
                                    '<div class="fl-preview__page-right">' +
                                        '<img src="' + photo + '" alt="" draggable="false">' +
                                        '<div class="fl-preview__line" style="width:80%"></div>' +
                                        '<div class="fl-preview__line" style="width:55%"></div>' +
                                    '</div>' +
                                '</div>' +
                                '<div class="fl-preview__lens"></div>' +
                            '</div>' +
                            '<div class="fl-preview__body">' +
                                '<h2 class="fl-preview__title" id="flPreviewTitle">' + title + '</h2>' +
                                '<p class="fl-preview__text" id="flPreviewText">' + fx.text("Assurez-vous de n'avoir rien oublié avant de commander.") + '</p>' +
                                '<button type="button" class="fl-preview__cta" data-testid="preview-ready-continue">' +
                                    fx.text("Vérifier mon album") +
                                    '<svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>' +
                                '</button>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                '</div>';
    }

});
